var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithubSocial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_81_790)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.25 2.77185C24.8028 2.77185 21.3894 3.45083 18.2046 4.77001C15.0198 6.0892 12.126 8.02276 9.68845 10.4603C4.76562 15.3831 2 22.0599 2 29.0219C2 40.6244 9.53375 50.4681 19.955 53.9594C21.2675 54.1693 21.6875 53.3556 21.6875 52.6469V48.2106C14.4163 49.7856 12.8675 44.6931 12.8675 44.6931C11.66 41.6481 9.95375 40.8344 9.95375 40.8344C7.565 39.2069 10.1375 39.2593 10.1375 39.2593C12.7625 39.4431 14.1538 41.9631 14.1538 41.9631C16.4375 45.9531 20.2962 44.7719 21.7925 44.1418C22.0287 42.4356 22.7113 41.2806 23.4463 40.6244C17.6188 39.9681 11.5025 37.7106 11.5025 27.7094C11.5025 24.7956 12.5 22.4594 14.2063 20.5956C13.9438 19.9394 13.025 17.2094 14.4688 13.6656C14.4688 13.6656 16.6737 12.9569 21.6875 16.3431C23.7612 15.7656 26.0187 15.4769 28.25 15.4769C30.4813 15.4769 32.7388 15.7656 34.8125 16.3431C39.8262 12.9569 42.0312 13.6656 42.0312 13.6656C43.475 17.2094 42.5563 19.9394 42.2938 20.5956C44 22.4594 44.9975 24.7956 44.9975 27.7094C44.9975 37.7369 38.855 39.9418 33.0013 40.5981C33.9463 41.4118 34.8125 43.0131 34.8125 45.4543V52.6469C34.8125 53.3556 35.2325 54.1956 36.5713 53.9594C46.9925 50.4418 54.5 40.6244 54.5 29.0219C54.5 25.5747 53.821 22.1612 52.5018 18.9764C51.1827 15.7916 49.2491 12.8978 46.8116 10.4603C44.374 8.02276 41.4802 6.0892 38.2954 4.77001C35.1106 3.45083 31.6972 2.77185 28.25 2.77185Z",
    fill: "#E8E8E8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_81_790",
    x: 0,
    y: 0.771851,
    width: 56.5,
    height: 55.2281,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_81_790"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_81_790",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubSocial);
export default __webpack_public_path__ + "static/media/githubSocial.e030462c556562a949f6e22f7250b759.svg";
export { ForwardRef as ReactComponent };